module.exports = __webpack_public_path__ + "img/202402_08.125a0d1e.jpg";